import CheckoutSplitPayLearnMore from './CheckoutSplitPayLearnMore';

export default CheckoutSplitPayLearnMore;
